import { getUrl, requests } from "../../globals/requests";
import { LOADING_GET_INVESTMENTS, GET_INVESTMENTS } from "../types";

export const getInvestments = () => {
  return async (dispatch) => {
    try {
      dispatch({
        type: LOADING_GET_INVESTMENTS,
        payload: true,
      });
      const url = getUrl("investments");
      const response = await requests.getWithAuth(url);

      dispatch({
        type: GET_INVESTMENTS,
        payload: response.data,
      });

      dispatch({
        type: LOADING_GET_INVESTMENTS,
        payload: false,
      });
      return response.data;
    } catch (e) {
      dispatch({
        type: LOADING_GET_INVESTMENTS,
        payload: false,
      });
      throw e;
    }
  };
};
